import { Link } from 'react-router';

export function ImprintPage() {
  return (
    <div className="min-h-screen bg-base-100">
      {/* Nav */}
      <nav className="flex items-center justify-between px-6 lg:px-12 py-4 border-b border-base-300/30">
        <Link to="/">
          <div className="text-2xl font-extrabold tracking-tight">
            Hy<span className="text-primary">Pe</span>Ma
          </div>
        </Link>
        <Link to="/login" className="btn btn-ghost btn-sm text-base-content/60">
          Login
        </Link>
      </nav>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-16">
        <h1 className="text-3xl font-bold tracking-tight mb-2">Impressum</h1>
        <p className="text-sm text-base-content/40 mb-10">Angaben gem&auml;&szlig; &sect; 5 DDG</p>

        <div className="space-y-10 text-base-content/70 text-sm leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">Angaben gem&auml;&szlig; &sect; 5 DDG</h2>
            <p>
              OXO UG (haftungsbeschr&auml;nkt)<br />
              R&uuml;benackerweg 2<br />
              82418 Seehausen am Staffelsee<br />
              Deutschland
            </p>
            <p className="mt-3">
              <strong>Vertreten durch:</strong><br />
              Gesch&auml;ftsf&uuml;hrer: Robert Stammen
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">Kontakt</h2>
            <p>
              Telefon: +49-89-5787-5350<br />
              E-Mail:{' '}
              <a href="mailto:service@newstelligent.com" className="text-primary hover:underline">
                service@newstelligent.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">Handelsregister</h2>
            <p>
              Registergericht: Amtsgericht M&uuml;nchen<br />
              Registernummer: HRB 223114
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
              DE304712598
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">
              Verantwortlich f&uuml;r den Inhalt nach &sect; 18 Abs. 2 MStV
            </h2>
            <p>
              Robert Stammen<br />
              R&uuml;benackerweg 2<br />
              82418 Seehausen am Staffelsee<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">EU-Streitschlichtung</h2>
            <p className="mb-3">
              Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
              bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-base-content mb-3">Haftungsausschluss</h2>

            <h3 className="font-medium text-base-content mb-2">Haftung f&uuml;r Inhalte</h3>
            <p className="mb-4">
              Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs. 1 DDG f&uuml;r eigene Inhalte auf
              diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 DDG
              sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte oder
              gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen,
              die auf eine rechtswidrige T&auml;tigkeit hinweisen.
            </p>
            <p className="mb-6">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist
              jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m&ouml;glich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
              entfernen.
            </p>

            <h3 className="font-medium text-base-content mb-2">Haftung f&uuml;r Links</h3>
            <p className="mb-6">
              Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine
              Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
              Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige
              Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mb-6">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h3 className="font-medium text-base-content mb-2">Urheberrecht</h3>
            <p className="mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
              dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art
              der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen der schriftlichen
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
              nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-base-300/30 py-8 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto flex items-center justify-between text-xs text-base-content/30">
          <span>Hy<span className="text-primary/60">Pe</span>Ma</span>
          <span>Precision over volume.</span>
        </div>
      </footer>
    </div>
  );
}
